import history from 'unsubscribe-ui/utils/history';
import { BREAKPOINTS } from 'unsubscribe-ui/constants';
export const getDataParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('data') || '';
};
export const getCurrentPathname = () => window.location.pathname;
export const moveToPage = (target, stateData) => history.replace(target, stateData);
export const redirectToUrl = url => {
  window.location.href = url;
};

// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
export const isLocal = () => window.location.hostname === 'local.hubspotqa.com';
export const isMobileView = () => window.innerWidth < parseInt(BREAKPOINTS.tablet, 10);